var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck, "_classCallCheck");
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
__name(_defineProperties, "_defineProperties");
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
__name(_createClass, "_createClass");
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
__name(_callSuper, "_callSuper");
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
__name(_possibleConstructorReturn, "_possibleConstructorReturn");
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
__name(_assertThisInitialized, "_assertThisInitialized");
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = /* @__PURE__ */ __name(function _isNativeReflectConstruct2() {
    return !!t;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct, "_isNativeReflectConstruct");
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
__name(_getPrototypeOf, "_getPrototypeOf");
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf(t, e);
}
__name(_inherits, "_inherits");
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
__name(_setPrototypeOf, "_setPrototypeOf");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import classNames from "classnames";
import React, { Children, Component } from "react";
import { gridEvenColumnsCls, gridEvenColumnsFlexboxCls, gridEvenColumnsColCls, gridEvenColumnsVisibleItemCls } from "./Columns.less";
var GridEvenColumns = /* @__PURE__ */ function(_Component) {
  function GridEvenColumns2(props) {
    var _this;
    _classCallCheck(this, GridEvenColumns2);
    _this = _callSuper(this, GridEvenColumns2, [props]);
    _defineProperty(_this, "totalChildren", 0);
    _this.gridRef = /* @__PURE__ */ React.createRef();
    _this.state = {
      columns: {
        first: [],
        second: []
      },
      wasMounted: false
    };
    _this.totalChildren = GridEvenColumns2.calcTotalValidChildren(_this.props.children);
    return _this;
  }
  __name(GridEvenColumns2, "GridEvenColumns");
  _inherits(GridEvenColumns2, _Component);
  return _createClass(GridEvenColumns2, [{
    key: "componentDidMount",
    value: /* @__PURE__ */ __name(function componentDidMount() {
      this.separateByColumns();
    }, "componentDidMount")
    /**
     * componentDidUpdate
     *
     * @param {Props} prevProps
     */
  }, {
    key: "componentDidUpdate",
    value: /* @__PURE__ */ __name(function componentDidUpdate(prevProps) {
      this.totalChildren = GridEvenColumns2.calcTotalValidChildren(this.props.children);
      if (!this.props.skip && GridEvenColumns2.calcTotalValidChildren(prevProps.children) !== this.totalChildren) {
        this.setState({
          columns: {
            first: [],
            second: []
          },
          wasMounted: false
        }, this.separateByColumns);
      }
    }, "componentDidUpdate")
    /**
     * separateByColumns
     */
  }, {
    key: "separateByColumns",
    value: /* @__PURE__ */ __name(function separateByColumns() {
      if (!this.props.skip && this.totalChildren > 2 && this.gridRef && this.gridRef.current) {
        var gridNode = this.gridRef.current;
        var childrenNodes = gridNode.querySelectorAll(".".concat(gridEvenColumnsColCls, " > *"));
        var totalNodes = childrenNodes ? childrenNodes.length : 0;
        var columns = {
          first: [],
          second: []
        };
        if (totalNodes) {
          var accumulatedHeight = 0;
          var _gridNode$getBounding = gridNode.getBoundingClientRect(), containerHeight = _gridNode$getBounding.height;
          var halfHeight = containerHeight / 2;
          var _this$props$itemMargi = this.props.itemMargin, itemMargin = _this$props$itemMargi === void 0 ? 0 : _this$props$itemMargi;
          for (var i = 0; i < totalNodes; i++) {
            var item = childrenNodes[i];
            var _item$getBoundingClie = item.getBoundingClientRect(), height = _item$getBoundingClie.height;
            var newlyHeight = accumulatedHeight + itemMargin + height;
            var columnKey = i === 0 || newlyHeight <= halfHeight ? "first" : "second";
            accumulatedHeight = newlyHeight;
            columns[columnKey].push(i);
          }
          this.setState({
            columns,
            wasMounted: true
          });
        }
      }
    }, "separateByColumns")
    /**
     * render
     */
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function render() {
      var children = this.props.children;
      var _this$state = this.state, columns = _this$state.columns, wasMounted = _this$state.wasMounted;
      this.totalChildren = GridEvenColumns2.calcTotalValidChildren(children);
      if (!this.totalChildren) {
        return null;
      }
      if (this.props.skip) {
        return /* @__PURE__ */ React.createElement("div", {
          className: classNames(gridEvenColumnsCls, gridEvenColumnsFlexboxCls)
        }, children);
      }
      if (this.totalChildren <= 2) {
        return /* @__PURE__ */ React.createElement("div", {
          className: classNames(gridEvenColumnsCls, gridEvenColumnsFlexboxCls)
        }, children.map(function(child, key) {
          return child ? (
            // eslint-disable-next-line react/no-array-index-key
            /* @__PURE__ */ React.createElement("div", {
              className: gridEvenColumnsColCls,
              key
            }, child)
          ) : null;
        }));
      }
      if (wasMounted) {
        if (!columns.first.length && !columns.second.length) {
          return null;
        }
        var contentChildren = Children.toArray(children).filter(function(child) {
          return !!child;
        });
        return /* @__PURE__ */ React.createElement("div", {
          className: classNames(gridEvenColumnsCls, gridEvenColumnsFlexboxCls)
        }, /* @__PURE__ */ React.createElement("div", {
          className: gridEvenColumnsColCls
        }, columns.first.map(function(key) {
          return contentChildren[key] || null;
        })), columns.second && columns.second.length ? /* @__PURE__ */ React.createElement("div", {
          className: gridEvenColumnsColCls
        }, columns.second.map(function(key) {
          return contentChildren[key] || null;
        })) : null);
      }
      return /* @__PURE__ */ React.createElement("div", {
        className: gridEvenColumnsCls,
        ref: this.gridRef
      }, /* @__PURE__ */ React.createElement("div", {
        className: gridEvenColumnsColCls
      }, children));
    }, "render")
  }], [{
    key: "calcTotalValidChildren",
    value: (
      /**
       * calcTotalValidChildren
       *
       * @param {*} children
       */
      /* @__PURE__ */ __name(function calcTotalValidChildren(children) {
        return children && children.length ? React.Children.count(children.filter(function(child) {
          return !!child;
        })) : 0;
      }, "calcTotalValidChildren")
    )
  }]);
}(Component);
_defineProperty(GridEvenColumns, "defaultProps", {
  skip: false,
  itemMargin: 0
});
export {
  GridEvenColumns,
  gridEvenColumnsVisibleItemCls
};
